import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Building2, Save, FileSignature } from "lucide-react";
import { ContractUpdateCard } from "@/components/ContractUpdateCard";

const FIELDS = [
  ["name", "Ragione sociale"], ["alias", "Alias"], ["address", "Indirizzo"],
  ["vat", "Partita IVA"], ["sdi", "Codice destinatario (SDI)"], ["email", "Email"], ["pec", "PEC"],
  ["bank_name", "Banca"], ["payment_type", "Tipologia pagamento"], ["iban", "IBAN"], ["iban_holder", "Intestatario conto"],
];

export default function AdminPlatform() {
  const [owner, setOwner] = useState({});
  const [text, setText] = useState("");
  const [privacy, setPrivacy] = useState("");
  const [version, setVersion] = useState("1.0");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/settings/platform").then((r) => { setOwner(r.data.owner || {}); setText(r.data.contract_text || ""); setPrivacy(r.data.privacy_text || ""); setVersion(r.data.contract_version || "1.0"); }).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/settings/platform", { owner, contract_text: text, privacy_text: privacy, contract_version: version });
      toast.success("Dati piattaforma e contratto salvati");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore salvataggio"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="admin-platform-page">
      <div>
        <div className="flex items-center gap-2 text-primary"><Building2 className="w-5 h-5" /><span className="text-xs font-medium tracking-wider uppercase">Impostazioni</span></div>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Contratto & Dati piattaforma</h1>
        <p className="text-sm text-muted-foreground mt-1">Intestazione usata nel contratto firmato dai dealer e testo del contratto.</p>
      </div>

      <Card className="p-6 glow-border space-y-3" data-testid="admin-platform-owner">
        <p className="font-head font-semibold flex items-center gap-2"><Building2 className="w-4 h-4" /> Proprietario piattaforma</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {FIELDS.map(([k, lbl]) => (
            <div key={k}><Label>{lbl}</Label><Input className="mt-1.5" value={owner[k] || ""} onChange={(e) => setOwner({ ...owner, [k]: e.target.value })} data-testid={`platform-${k}`} /></div>
          ))}
        </div>
      </Card>

      <ContractUpdateCard onPublished={load} />

      <Card className="p-6 glow-border space-y-3" data-testid="admin-platform-contract">
        <p className="font-head font-semibold flex items-center gap-2"><FileSignature className="w-4 h-4" /> Testo del contratto</p>
        <div className="w-40"><Label>Versione</Label><Input className="mt-1.5" value={version} onChange={(e) => setVersion(e.target.value)} data-testid="platform-version" /></div>
        <p className="text-xs text-muted-foreground">Modificando la versione, i dealer dovranno rifirmare il contratto con SMS entro 30 giorni (nel frattempo continuano a operare).</p>
        <textarea rows={16} className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm font-mono" value={text} onChange={(e) => setText(e.target.value)} data-testid="platform-contract-text" />
      </Card>

      <Card className="p-6 glow-border space-y-3" data-testid="admin-platform-privacy">
        <p className="font-head font-semibold flex items-center gap-2"><FileSignature className="w-4 h-4" /> Informativa privacy (GDPR)</p>
        <p className="text-xs text-muted-foreground">Testo mostrato al dealer nel riquadro scorrevole della privacy, prima della firma.</p>
        <textarea rows={16} className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm font-mono" value={privacy} onChange={(e) => setPrivacy(e.target.value)} data-testid="platform-privacy-text" />
      </Card>

      <Button className="gap-2" disabled={busy} onClick={save} data-testid="platform-save"><Save className="w-4 h-4" /> {busy ? "Salvataggio…" : "Salva"}</Button>
    </div>
  );
}
